/**
 * PageNav: A class that toggles toggleable elements with a toggleclass
 *
 * Put two arguments on the element that triggers the toggle:
 * - data-toggles = Target that will be toggled
 * - data-toggles-class = Class that will be appended, defaults to 'is--visible'
 *
 */
;(function ($, window) {
    'use strict';

    /**
     * Sticky component constructor
     * @param $element
     * @param targets
     * @constructor
     */
    var PageNav = function ($element, targets) {
        this._$el = $element;
        this._targets = $('body').find('.'+targets);
        this.nav = [];
        // this._$el.on('click', this.toggle.bind(this));
        this.init();
    };

    /**
     * Init Function
     */
     PageNav.prototype.init = function () {

      var self = this;
      this._targets.each(function () {
        var item = $('<li class="index-list__item">'),
            link = $('<button class="btn-link-blue">'+$(this).data('nav-name')+'</button>'),
            el = this;

        link.bind('click', function(e){
          // console.log(el);
          $('html, body').animate({
            scrollTop: $(el).offset().top
          }, 600);
          e.preventDefault();
        });
        item.append(link);
        self.nav.push($(item));
      });

      this._$el.append(this.nav);
    };


    /**
     * Attach listeners to document
     */
    $(function () {
        var $elements = $('[data-page-nav]');
        $elements.each(function () {
            var $el = $(this),
                targets = $el.data('targets');
            new PageNav($el, targets);
        });
    })

})(jQuery, window);
